import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { Calendar, MapPin, Users } from "lucide-react";

export default function Actions() {
  const { t } = useI18n();
  const [actions, setActions] = useState([]);
  useEffect(() => { api.get("/actions").then(r => setActions(r.data)).catch(() => {}); }, []);

  const renderMedia = (a) => {
    if (!a.media_url) {
      return <div className="h-48 bg-gradient-to-br from-deep-blue to-deep-blue-light"></div>;
    }
    if (a.media_type === "video") {
      return (
        <video
          src={a.media_url}
          controls
          preload="metadata"
          className="w-full h-48 object-cover bg-black"
          data-testid={`action-video-${a.id}`}
        />
      );
    }
    return (
      <img
        src={a.media_url}
        alt={a.title || ""}
        className="w-full h-48 object-cover"
        data-testid={`action-image-${a.id}`}
        loading="lazy"
      />
    );
  };

  return (
    <div data-testid="actions-page">
      <section className="hero-gradient py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.actions.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">{t("pages.actions.t1")}<br/><span className="italic text-warm-orange">{t("pages.actions.t2")}</span></h1>
          <p className="text-deep-blue/70 mt-6 max-w-2xl">{t("pages.actions.sub")}</p>
        </div>
      </section>
      <section className="py-16 bg-ivory">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          {actions.length === 0 ? (
            <div className="p-12 rounded-2xl bg-pearl text-center">
              <p className="font-display text-2xl text-deep-blue">{t("actions.empty1")}</p>
              <p className="text-deep-blue/60 mt-2">{t("actions.empty2")}</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {actions.map(a => (
                <article key={a.id} className="card-elev rounded-2xl overflow-hidden" data-testid={`action-${a.id}`}>
                  {renderMedia(a)}
                  <div className="p-6">
                    <h3 className="font-display text-xl text-deep-blue">{a.title}</h3>
                    <div className="flex flex-wrap gap-3 text-xs text-deep-blue/60 mt-3">
                      {a.date && <span className="inline-flex items-center gap-1"><Calendar size={12}/>{a.date}</span>}
                      {a.location && <span className="inline-flex items-center gap-1"><MapPin size={12}/>{a.location}</span>}
                      {a.beneficiaries && <span className="inline-flex items-center gap-1"><Users size={12}/>{a.beneficiaries} {t("actions.beneficiaries")}</span>}
                    </div>
                    <p className="text-sm text-deep-blue/70 mt-3 whitespace-pre-line">{a.description}</p>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
